<template>
  <main-layout>
    <v-tabs v-model="currentTab" slider-color="primary" @change="handleTabChange">
      <v-tab v-for="tab in tabs" :key="tab.href" :href="tab.href">{{ tab.text }}</v-tab>
    </v-tabs>
    <v-container>
      <template v-if="currentTab === 'position_management'">
        <Position />
      </template>
      <template v-else-if="currentTab === 'department_management'">
        <Department />
      </template>
      <template v-else-if="currentTab === 'ranking_report'">
        <RankingReport />
      </template>
      <template v-else-if="currentTab === 'issue_report'"> <IssueReport /></template>
    </v-container>
  </main-layout>
</template>

<script>
import Position from './position/Position.vue'
import Department from './department/Department.vue'
import RankingReport from './RankingReport.vue'
import IssueReport from './issueReport/IssueReport.vue'

export default {
  components: { Position, Department, RankingReport, IssueReport },
  data() {
    return {
      currentTab: this.$route.query.tab || 'position_management',
      tabs: [
        { text: this.$t('position_management'), href: '#position_management' },
        { text: this.$t('department_management'), href: '#department_management' },
        { text: this.$t('ranking_report'), href: '#ranking_report' },
        { text: this.$t('issue_report'), href: '#issue_report' }
      ]
    }
  },
  methods: {
    handleTabChange(value) {
      this.$router.replace({ query: { tab: value } })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/Reporting.vue